import dayjs from 'dayjs';

export const getExpirationDate = (year?: number, month?: number) => dayjs(`${year}-${month}-01`).format('MM/YY');
